import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';
import {TableComponent} from '../../../../components/table/table.component';

@Component({
  selector: 'app-authenticated-administration-publications-index',
  templateUrl: './index.component.html',
  imports: [
    TranslatePipe,
    RouterLink,
    TableComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.administration.publications.index.title');
  }
}
